// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3kHBF","col":"styles_col__3hsE2"};